export enum Gender {
  Male = "M",
  Female = "F",
  Unassigned = "U",
}

const Colors = {
  [Gender.Female]: "#F09",
  [Gender.Male]: "#09F",
};

export function getGenderColor(gender: Gender | "XX"): string {
  return Colors[gender] || "#CCC";
}

export function getAllGenders(
  excludeUnasigned?: boolean
): (Gender.Male | Gender.Female)[];
export function getAllGenders(excludeUnasigned?: boolean): Gender[] {
  if (excludeUnasigned) {
    return [Gender.Male, Gender.Female];
  }
  return [Gender.Male, Gender.Female, Gender.Unassigned];
}

export function isMaleGender(gender: Gender) {
  return gender === Gender.Male;
}
